/**
 * The provider wording every admin money surface shares.
 *
 * Card #53296. Before this module the map existed ONLY inside TransactionsPage.jsx, so the two
 * order surfaces had no way to name a provider without re-typing it — and a second copy is
 * precisely how "Merchant" on one screen becomes a raw `authorize_net` on another. The card this
 * module serves asks the three surfaces to AGREE, so the agreement is made structural here
 * rather than left to three authors remembering the same string.
 *
 * Mirrors PAYMENT_PROVIDERS in api/services/payment/paymentGateway.js. Labels are display only;
 * the wire value stays the snake_case identifier, so the URL and the API keep speaking it.
 */

export const PAYMENT_PROVIDERS = Object.freeze([
  Object.freeze({ value: 'authorize_net', label: 'Merchant' }),
  Object.freeze({ value: 'stripe', label: 'Stripe' })
]);

export const DEFAULT_PAYMENT_PROVIDER = 'authorize_net';

/**
 * Absent stays absent, and an UNKNOWN provider renders AS ITSELF.
 *
 * Falling back to the incumbent's label here would print "Merchant" beside a transaction some
 * other provider actually owns — a false attribution on a money surface, which is worse than an
 * unfamiliar word. Returning null (not '') lets the existing `v != null && v !== ''` row filters
 * on both order pages drop the row unchanged, so no caller needs a new empty state.
 */
export const formatProviderLabel = (value) =>
  value === null || value === undefined || value === ''
    ? null
    : PAYMENT_PROVIDERS.find((provider) => provider.value === value)?.label ?? value;

/** True only for a provider this UI actually knows how to name. */
export const isKnownProvider = (value) => PAYMENT_PROVIDERS.some((provider) => provider.value === value);
